import script from "./YouPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./YouPage.vue?vue&type=script&setup=true&lang=ts"

import "./YouPage.vue?vue&type=style&index=0&id=230a0952&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-230a0952"]])

export default __exports__